// Copyright (c) 2016 Deere & Company

import DealerSettings from './components/dealer-settings';
import actionCreators from '../shared/action-creators';
import {connect} from 'react-redux';
import {handleOnPageLeave} from '../shared/services/handle-on-page-leave';

const getStateToBindToContainerProps = state => ({
    ...state.user.preferences,
    userDealerSettings: state.user.details.settings.dealer
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps,
        handleOnPageLeave
    }
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(DealerSettings);



// WEBPACK FOOTER //
// ./src/user/dealer-settings/state-connector.js